import React from 'react';
import LoginPopup from '../../pages/user/login/loginpopup';
import SignupPopup from '../../pages/user/signup/signuppopup';
import { useSelector } from 'react-redux';
import { closeLoginPopup, closeSignupPopup } from '../../redux/actions/authActions';

const AuthPopups = () => {
    const openLogin = useSelector(state => state.auth.openLogin);
    const openSignup = useSelector(state => state.auth.openSignup);

    return (
        <>
            <LoginPopup open={openLogin} onClose={() => closeLoginPopup()} />
            <SignupPopup open={openSignup} onClose={() => closeSignupPopup()} />
        </>
    );
};

export default AuthPopups;